import React, { useEffect, Fragment } from "react";
import { connect } from "react-redux";

import { Field } from "react-final-form";

import { ToggleField, InputField, required, SmartSelect, ListArray, isNotEmpty, ReactDropzone } from "modules/4_final_form/mobile";

import { getProjectQaWeldingInspectionsFailureReasons } from "modules/project/qa/welding_inspections/failure_reasons/actions.js";

import { getProjectQaWeldingInspectionsInspectionCriterias } from "modules/project/qa/welding_inspections/inspection_criterias/actions.js";
import { getProjectQaWeldingInspectionsInspectionSpecs } from "modules/project/qa/welding_inspections/inspection_specs/actions.js";

import _ from "lodash";
import { Block, List } from "framework7-react";
import { FieldArray } from "react-final-form-arrays";
import { getWorkshops } from "modules/workshops/actions";

const mapStateToProps = (state) => {
  return {
    project_qa_welding_inspections_failure_reasons: state.project_qa_welding_inspections_failure_reasons,
    project_qa_welding_inspections_access_restrictions: state.project_qa_welding_inspections_access_restrictions,
    project_qa_welding_inspections_surface_conditions: state.project_qa_welding_inspections_surface_conditions,
    project_qa_welding_inspections_inspection_criterias: state.project_qa_welding_inspections_inspection_criterias,
    project_qa_welding_inspections_inspection_specs: state.project_qa_welding_inspections_inspection_specs,
    workshops: state.workshops,
  };
};

export const InspectionDetails = (props) => {
  useEffect(() => {
    props.getProjectQaWeldingInspectionsInspectionCriterias();
    props.getProjectQaWeldingInspectionsInspectionSpecs();
    props.getProjectQaWeldingInspectionsFailureReasons();
    props.getWorkshops();
  }, []);

  const {
    project_qa_welding_inspections_failure_reasons,
    project_qa_welding_inspections_access_restrictions,
    project_qa_welding_inspections_surface_conditions,
    project_qa_welding_inspections_inspection_specs,
    project_qa_welding_inspections_inspection_criterias,
    form: { change },
    values: { complies, surface_condition_id, access_restriction_id },
    handleSubmit,
    workshops,
    edit,
  } = props;

  const selected_access_restriction = project_qa_welding_inspections_access_restrictions[access_restriction_id];
  const selected_surface_condition = project_qa_welding_inspections_surface_conditions[surface_condition_id];
  const voided_inspection = selected_access_restriction?.voids_inspection || selected_surface_condition?.voids_inspection;

  const default_inspection_spec = _.find(project_qa_welding_inspections_inspection_specs, (ar) => ar.default);
  const default_inspection_criteria = _.find(project_qa_welding_inspections_inspection_criterias, (ar) => ar.default);

  let voided_inspection_label = "Voided Inspection - By ";
  if (selected_access_restriction?.voids_inspection) {
    voided_inspection_label += "Access Restriction";
  }
  if (selected_surface_condition?.voids_inspection) {
    if (selected_access_restriction?.voids_inspection) {
      voided_inspection_label += " and";
    }
    voided_inspection_label += " Surface Condition";
  }

  return (
    <Fragment>
      <List>
        <Field component={ToggleField} label="Complies" slot="list" name="complies" disabled={voided_inspection} />
        {edit && <Field component={ToggleField} label="Audited" slot="list" name="audited" />}
        <Field
          component={SmartSelect}
          name="inspection_criteria_id"
          options={_.map(project_qa_welding_inspections_inspection_criterias, (ic) => {
            return {
              label: ic.name,
              value: ic.id,
            };
          })}
          label="Inspection Criteria"
          validate={required}
          slot="list"
          labelName="label"
          valueName="value"
          defaultValue={default_inspection_criteria?.id}
        />
        <Field
          component={SmartSelect}
          name="inspection_spec_id"
          label="Inspection Specs"
          options={_.map(project_qa_welding_inspections_inspection_specs, (is) => {
            return {
              label: is.name,
              value: is.id,
            };
          })}
          validate={required}
          slot="list"
          labelName="label"
          valueName="value"
          defaultValue={default_inspection_spec?.id}
        />
        <Field
          component={SmartSelect}
          name="workshop_id"
          label="Workshop"
          options={_.map(workshops, (ws) => {
            return {
              label: ws.name,
              value: ws.id,
            };
          })}
          validate={required}
          slot="list"
          labelName="label"
          valueName="value"
        />
        <Field component={InputField} type="textarea" slot="list" label="Notes" name="notes" parse={(value) => value} />
      </List>
      {!complies && !voided_inspection && (
        <Block>
          <FieldArray
            component={ListArray}
            name="failure_reasons_attributes"
            slot="list"
            validate={isNotEmpty}
            handleSubmit={handleSubmit}
            columns={(thisField, i) => {
              const selectedFailureReason = project_qa_welding_inspections_failure_reasons?.[thisField.reason_id];

              return [
                {
                  name: "reason_id",
                  label: "Reason",
                  component: SmartSelect,
                  labelName: "label",
                  valueName: "value",
                  options: _.map(project_qa_welding_inspections_failure_reasons, (fr) => {
                    return {
                      label: fr.name,
                      value: fr.id,
                    };
                  }),
                  validate: required,
                  onChange: () => {
                    change(`failure_reasons_attributes[${i}].reason_detail_id`, null);
                  },
                },
                {
                  name: "reason_detail_id",
                  label: "Reason Detail",
                  component: SmartSelect,
                  labelName: "label",
                  valueName: "value",
                  options: _.map(selectedFailureReason?.details_attributes, (det) => {
                    return {
                      label: det.name,
                      value: det.id,
                    };
                  }),
                  validate: required,
                },
                {
                  name: "location",
                  label: "Location",
                  component: InputField,
                  validate: required,
                },
                {
                  name: "notes",
                  label: "Notes",
                  component: InputField,
                  type: "textarea",
                },
                {
                  name: "attachments_attributes",
                  label: "Photo/s of failure",
                  fieldArray: true,
                  component: ReactDropzone,
                },
              ];
            }}
            label="Failure Reasons"
            itemLabel="Failure Reason"
            buttonLabel="Add Failure Reason"
          />
        </Block>
      )}
    </Fragment>
  );
};

export default connect(mapStateToProps, {
  getProjectQaWeldingInspectionsFailureReasons,
  getProjectQaWeldingInspectionsInspectionSpecs,
  getProjectQaWeldingInspectionsInspectionCriterias,
  getWorkshops,
})(InspectionDetails);

const FailureReasonAttributes = () => {
  return;
};
